export default __webpack_public_path__ + "assets/webgl/controllers_btns.8ee4dde5.gltf";